import React from 'react';

export default function RouteFallback() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center bg-linen-canvas">
      <div
        className="h-10 w-10 animate-spin rounded-full border-2 border-hairline border-t-signal"
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}
